import type { EventContentObjectDetail, Program, ProgramEvent, ProgramEventType, ProgramInviteType } from 'models';

import { type DefaultEventData, DefaultEventForm, type DefaultEventFormValues } from './default-event-form';

export { type DefaultEventData, type DefaultEventFormValues } from './default-event-form';

type P = {
  eventContentObject?: EventContentObjectDetail;
  eventType: ProgramEventType;
  initialDefaultData?: Partial<DefaultEventFormValues>;
  inviteType: ProgramInviteType;
  isLoading: boolean;
  mode: 'create' | 'duplicate' | 'edit';
  onCancel?: () => void;
  onInviteesTypeChanged: (type: ProgramInviteType) => void;
  onSubmit: (data: DefaultEventData, event?: ProgramEvent) => Promise<void> | void;
  program?: Program;
};

const DataStepEventForm = ({ eventType, initialDefaultData, ...props }: P) => (
  <DefaultEventForm eventType={eventType} initialData={initialDefaultData} {...props} />
);

export default DataStepEventForm;
